module.exports = __webpack_public_path__ + "assets/img/ContactUsBAPC.e5825e91.png";